import { render, staticRenderFns } from "./FooterBottomNew.vue?vue&type=template&id=0709db68&scoped=true"
import script from "./FooterBottomNew.vue?vue&type=script&lang=js"
export * from "./FooterBottomNew.vue?vue&type=script&lang=js"
import style0 from "./FooterBottomNew.vue?vue&type=style&index=0&id=0709db68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0709db68",
  null
  
)

export default component.exports